import { CookieStoreService } from './modules/shared/services/cookie-store.service';
import { reportsSecondLevelMenuData } from './reports/reports-menu.data';
import { DashboardWidgetListModels } from './profile/dashboard/models/dashboard-widget-list.models';
import { DashboardService } from './profile/dashboard/services/dashboard.service';
import { COMPANY_DEFAULT_LOGO } from './modules/shared/constants/company-default-logo';
import { DashboardDataServiceActions, DashboardDataServiceActionsValues } from './profile/dashboard/models/dashboard-data-service-action.models';
import { DashboardContentChartTypes, typeDashboardContentChartTypes } from './profile/dashboard/models/dashboard-content-items.models';
import { DashboardDataService } from './profile/dashboard/services/dashboard-data.service';
import { CurrencyService } from './modules/shared/services/currency.service';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { TranslocoService } from '@ngneat/transloco';
import * as CryptoJS from 'crypto-js';
import * as moment from "moment";
import * as momentTz from "moment-timezone";
import { convertToLocalDate } from './modules/shared/helpers/convert-to-local-date.helper';
import { ApprovalActivityInfo } from './modules/shared/model/approval/approval-info';
import { ModuleType } from './modules/shared/enums/module-type.enum';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { LogService } from './../app/shared/shared-logs/log-service.service';
import { AppMainService } from './app-main.service';
import { MenuService } from './app.menu.service';
import { ConfigurationService } from './configurations/configurationService';
import { Status } from './models/statusEnums';
import { QuestionnaireService } from './more/questionnaire/questionnaire.service';
import { NotificationService } from './notifications/notificationService';
import { ProfileService } from './profile/profileService';
import { AccountUserService } from './service/account.service';
import { UserData } from './service/userdata';
import { UserService } from './service/userservice';
import { NoteService, ObjectEmailAuditService, ObjectLogService, ObjectNoteService, ObjectTaskService, RecipientTypeService, RepeatTypeService, TaskService } from './shared/api/api';
import { ActivityService } from './shared/shared-activities/activity.service';
import { VendorOAuthRegistrationUserService, VendorService } from './shared/shared-emails/Integration/api/api';
import { Type } from './shared/shared-emails/Integration/model/type';
import { VendorOAuthRegistrationUser } from './shared/shared-emails/model/models';
import { ImportExcelService } from './service/import-excel.service';
import { Account } from './accounts-v2/models/account.model';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { arrayGroupByKey } from './modules/shared/helpers/array-groupby.helper';
import { DashboardViewContentWidgetModels } from './profile/dashboard/models/dashboard-view-details.models';
import { OverdueNotificationService } from './service/overdue-notification.service';
import { TypeGroupIds } from './modules/shared/constants/category-groupid.constants';
import { LocalDatePipe } from './modules/shared/pipes/local-date.pipe';
import { AccountModuleId, CaseModuleId, InvoiceOrderModuleId, LeadModuleId, OpportunityModuleId, workspaceModuleName } from './modules/shared/constants/modules.constant';
import { ActivityDataService } from './modules/shared/components/shared-activities/activity-data.service';
import { ObjectNames } from './shared/constants';
import { PhoneNumberFormatService } from './modules/shared/services/phone-number-format.service';
import { TasksService } from './profile/tasks';
import { ImportserialService } from './modules/shared/services/importserial.service';
import { environment } from 'src/environments/environment';
import { EmailService } from './modules/shared/components/shared-emails/email.service';
import { CategoryService } from './modules/shared/components/shared-emails/Integration/api/category.service';
import { WBParentComment } from './misc/workspace/models/workbook-comment.models';
import { NotificationReadUnread } from './shared/model/notificationReadUnread';
import { ReadActivitiesByIdsPayload } from './modules/shared/models/activity-list-payload.model';
import { SettingService } from './configurations/inventory/setting/setting.service';
import { UtilityService } from './inventory/sales-order/utils/utility.service';


@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss'],
    providers: [ImportExcelService, LocalDatePipe, CategoryService]
})
export class AppMainComponent implements OnInit, OnDestroy {

    @ViewChild("Usermenubar") dashboardWidgetsMenu: any;
    @ViewChild("Notificationbar") notificationSideMenu: any;
    public menuMode = 'horizontal';
    public menuActive = false;
    public topbarMenuActive = false;
    public questionMenuActive = false;
    activeTopbarItem: Element;
    menuClick: boolean;
    menuButtonClick: boolean;
    topbarMenuButtonClick: boolean;
    questionMenuClick: boolean;
    menuHoverActive: boolean;
    inputStyle = 'outlined';
    ripple: boolean;
    configActive: boolean;
    configClick: boolean;
    questionnaireVisitTypes: any[] = [];
    private destroy$ = new Subject<void>();

    selectedModuleId: number;
    selectedAccountId: number;

    resetMenu: boolean;
    public usersList: any[] = [];
    public dashboardWidgets: any[] = [];
    public dashboardWidgetsList: DashboardViewContentWidgetModels[] = null;
    public summaryWidgetsList: DashboardViewContentWidgetModels[] = null;
    public menu: any[] = [];
    public currentUser = {
        id: 0, name: "", fname: "", lname: "", role: "", email: "", menuMode: "horizontal", inputStyle: "outlined", ripple: false, layout: "cosmic", theme: "green", landingPage: "/", username: "", dashboard: [],
        leadDefaultView: "", casesDefaultView: "", opportunityDefaultView: "", accountDefaultView: "", contactDefaultView: "", terriDefaultView: "", questionnaireDefaultView: "", menu: [],
        leadStepBar: true, accountStepBar: true, contactStepBar: true, casesStepBar: true, terriStepBar: false, questionnaireStepBar: false
    };
    public displayDashboard = false;
    public displayAlerts = false;
    public userRoles = [];
    public availableMenus = [];
    public companyId = 3;
    public companyName = "";
    public userIP = "142.250.217.100";
    public curDate = new Date();
    public prevDate = new Date();
    public upcomingTasksAndEvents = [];
    public otherActivities = [];
    public objectId;
    public objectType;
    public objectTypeId;
    public allObjects;
    public preLoadedObjects = localStorage.getItem('LionO360_Object') ? JSON.parse(localStorage.getItem('LionO360_Object')) : [];
    public phoneType = TypeGroupIds.PhoneTypeId;
    public emailType = TypeGroupIds.EmailTypeId;
    public socialProfileType = TypeGroupIds.SocialTypeAccountAPI;
    public isShowImport = false;
    public isShowSpinner: boolean;
    public allActivityLogs: any[] = [];
    public loadingActivityLogs: boolean = false;

    public allActivityLogsList: any[] = [];
    public apiCreatedFields = {
        createdBy: this.companyId,
        createdSource: this.userIP,
        createdDate: this.curDate.toISOString(),
    }
    public apiUpdatedFields = {
        updatedBy: this.companyId,
        updatedSource: this.userIP,
        updatedDate: this.curDate.toISOString(),
    }
    public currentRoute = this.router.url;
    public userId = 9;
    configuredUser: VendorOAuthRegistrationUser;
    isConfigured: boolean;
    isSMTP: boolean;
    dashboardSetting = [];
    public emailRecipTypes: Type[] = [];
    public user;
    public userDetails;
    public organizationData;
    public notifications = [];
    public notificationsCopy = [];
    selectedNotification;
    displayNote = false;
    interval;
    public rolePermissions;
    public userPermissionsBSubject = new BehaviorSubject([]);
    public logTypesBSubject = new BehaviorSubject([]);
    public loggedUser;
    public configurationData = new BehaviorSubject([]);
    public dashboardconfigurationId: number;
    public appLogo = `${environment.assestsBasePath}layout/images/lionO360_logo1.png`;
    public profilePic = `${environment.assestsBasePath}layout/images/avatar5.png`;
    public eventRepeatType = [];
    public encryptSecretKey = "LionO3602.0CRM2021";
    public configuredUserBSubject = new BehaviorSubject(null);
    public allActivityLogsListErrorResponse;
    public selectedOrder = 'Sales Order';
    private userSavedSubscription: Subscription;

    name = 'Angular';
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    timeouttime: any = 600;
    resdata: any;
    countdown?: number = null;
    overdueMsgRead = false;

    // cookie
    isShowCookie: boolean = false;
    displayCookieSetting = false;
    isCookiesEnabled: boolean = false;
    cookies = [
        { id: 1, name: "Essential Cookies", isActive: true, disabled: true, description: "These cookies enable core functionality such as security, verification of identity and network management. These cookies can't be disabled." },
        { id: 2, name: "Enable User Preference Cookies", isActive: false, description: "These cookies are used to track advertising effectiveness to provide a more relevant service and deliver better ads to suit your interests." },
    ]

    accountDetails: Account | Partial<Account>;
    reportsAllMenus = reportsSecondLevelMenuData();

    scrHeight: any;

    //chatbot
    public displayChatBox = false;
    public chatBotInitializationData: any;
    public chatbotModule: string;
    public chatbotModules = [];
    public selectedChatbotWindow;

    //clock
    public timer;
    public isClocking = false;
    public displayEditViewTask = false;
    public selectedTaskId;
    public filterMode: string;

    //Approval dialog
    public displayViewApproval: boolean = false;
    public approvalActivityInfo: ApprovalActivityInfo;

    /**Comment Details Dialog */
    displayCommentDetailPopup: boolean = false;
    selectedParentComment: WBParentComment;
    workbookId: string;
    rowNumber: number;

    //log & note
    displayLogDetailPopup = false;
    displayNoteDetailPopup = false;

    logData: any;
    noteData: any;
    constructor(
        private cookieStoreService: CookieStoreService,
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public userService: UserService,
        public activityService: ActivityService,
        public objectLogService: ObjectLogService,
        public objectNoteService: ObjectNoteService,
        public objectTaskService: ObjectTaskService,
        public appMainService: AppMainService,
        private router: Router,
        private vendorUserService: VendorOAuthRegistrationUserService,
        private confirmationService: ConfirmationService,
        public messageService: MessageService,
        private zone: NgZone,
        public objectEmailAuditService: ObjectEmailAuditService,
        public typeService: RecipientTypeService,
        private accountService: AccountUserService,
        private activityTaskService: TaskService,
        private notificationService: NotificationService,
        private configService: ConfigurationService,
        private questionnaireService: QuestionnaireService,
        private profileService: ProfileService,
        private repeatTypeService: RepeatTypeService,
        private logService: LogService,
        private datePipe: DatePipe,
        public idle: Idle,
        private keepalive: Keepalive,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private currencyService: CurrencyService,
        private phoneNumberFormatService: PhoneNumberFormatService,
        private storeService: StoreService,
        private dashboardService: DashboardService,
        private dashboardDataService: DashboardDataService,
        private overdueNotificationService: OverdueNotificationService,
        private activityDataService: ActivityDataService,
        private tasksService: TasksService,
        private importService: ImportserialService,
        private categoryService: CategoryService,
        private vendorService: VendorService,
        private emailService: EmailService,
        private noteService: NoteService,
        private settingService: SettingService,
        private utilityService: UtilityService,
    ) {

        idle.setIdle(5); // how long can they be inactive before considered idle, in seconds
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active


        // do something when the user becomes idle
        idle.onIdleStart.subscribe(() => {
            this.idleState = "IDLE";
        });
        // do something when the user is no longer idle
        idle.onIdleEnd.subscribe(() => {
            this.idleState = "NOT_IDLE";
            this.countdown = null;
            cd.detectChanges(); // how do i avoid this kludge?
        });
        // do something when the user has timed out
        idle.onTimeout.subscribe(() => {
            this.idleState = 'Timed out!';
            this.timedOut = true;
            //  this.router.navigate(['/login']);
            this.logout(true);
        });
        // do something as the timeout countdown does its thing
        idle.onTimeoutWarning.subscribe(seconds => this.countdown = seconds);

        // set keepalive parameters, omit if not using keepalive
        keepalive.interval(15); // will ping at this interval while not idle, in seconds
        keepalive.onPing.subscribe(() => this.lastPing = new Date()); // do something when it pings

        idle.setTimeout(600); // how long can they be idle before considered timed out, in seconds
        //this.reset();

        this.configService
            .getDefaultTimeOutValue()
            .subscribe({
                next: (response) => {
                    const timeoutValue = response.find((item) => item.code === 'timeout')?.value ?? 2500000;
                    idle.setTimeout(timeoutValue);
                    this.reset();
                },
                error: (error) => { },
            });

        /////////end Nilesh///////////
        this.accountService.user.subscribe(x => {
            if (x) {
                this.userId = x.userId;
                this.user = x;
                UserData.user = x;
                if (this.user) {
                    this.openCookieDialog();
                    this.currencyService.getBaseCurrency();
                    this.phoneNumberFormatService.getPhoneNumberFormat();
                }

            }
        });

        this.activityService.getAllObjects().then((objects: any) => {
            this.preLoadedObjects = objects.filter(obj => obj.typeId == 65);
            localStorage.setItem('LionO360_Object', JSON.stringify(this.preLoadedObjects));
        });

    }

    ngOnInit() {
        // this.permissionService.changeUserPermissionByChannel(0);
        this.updateLocale('en-US');
        this.companyId = this.user.organizationId;
        this.accountService.user
        this.primengConfig.ripple = true;
        this.prevDate.setDate(this.curDate.getDate() - 1);
        this.userIP = this.user.userIP;

        this.appMainService.showSpinner
            .pipe(distinctUntilChanged())
            .subscribe((data) => {
                setTimeout(() => {
                    this.isShowSpinner = data
                }, 10);
            });

        this.configService
            .getDecimalAndQtyConfigByOrganizationId(this.user.organizationId)
            .subscribe({
                next: (org) => {
                    this.importService.setDecimalValue(org.decimalLimit);
                    this.importService.setQtyDecimalValue(org.qtyDecimalLimit);
                    const activeOrgCurrency = org.organizationCurrencies?.filter(cr => cr.statusId == 1);
                    this.importService.setOrgCurrency(activeOrgCurrency);
                },
                error: (error) => {
                },
        });

        this.configService.getOrganizationById(this.user.organizationId).subscribe(
            org => {
                this.organizationData = org;
                // this.importService.setDecimalValue(org.decimalLimit);
                // this.importService.setQtyDecimalValue(org.qtyDecimalLimit);
                // const activeOrgCurrency = org.organizationCurrencies?.filter(cr => cr.statusId == 1);
                // this.importService.setOrgCurrency(activeOrgCurrency);
                this.appLogo = org.image ? org.image.location : COMPANY_DEFAULT_LOGO;
            },
            err => {

        });
        this.userSavedSubscription = this.configService.userSaved$.subscribe(() => {
            this.userService.getUsers(this.companyId).then(users => {
                if (users?.length) { this.usersList = users.sort((a, b) => a.name.localeCompare(b.name)); }
            });
        })

        // this is to delay api call to render dashboard faster
        setTimeout(() => {
            this.repeatTypeService.lionO36020APIRepeatTypeGet().subscribe((types: any) => {
                this.eventRepeatType = types;
            });

            this.logService.getLogTypes().then((types: any) => {
                this.logTypesBSubject.next(types)
            });

            this.profileService.getuserProfile().then(res => {
                this.userDetails = res;
                localStorage.setItem('user', JSON.stringify({ userId: res.id, organizationId: res.organizationId }));
                this.profilePic = res?.profileImage && res?.profileImage.location ? res?.profileImage.location : this.profilePic;
            });

            this.userService.getUsers(this.companyId).then(users => {
                if (users && users.length) { this.usersList = users.sort((a, b) => a.name.localeCompare(b.name)); }
            });

            this.getNotifications();
            this.interval = setInterval(() => {
                this.getNotifications();
            }, 60000);

            //this.checkoutAccount();
            this.getAllCategory();
            this.getEmailRecipientsTypes();
            this.getQuestionnaireVisitTypes();


        }, 100);
        this.loadISettings();
    }
    loadISettings() {
        this.appMainService.isShowSpinner("loadISettings");
        this.settingService.getAllInventorySettings()
          .pipe(take(1))
          .subscribe((settings) => {
            this.utilityService.setISettings(settings);
            this.appMainService.isHideSpinner("loadISettings");
          });
      }
    reset() {
        this.idle.watch();
        this.idleState = "NOT_IDLE";
        this.countdown = null;
        this.lastPing = null;
        this.timedOut = false;
    }
    updateLocale(locale: any) {
        const lang = locale.substring(0, 2);
        this.translocoService.setActiveLang(lang);
    }

    encryptData(msg) {
        var keySize = 256;
        var salt = CryptoJS.lib.WordArray.random(16);
        var key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
            keySize: keySize / 32,
            iterations: 100
        });

        var iv = CryptoJS.lib.WordArray.random(128 / 8);

        var encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

        return result;
    }

    getuserName(userId) {
        return this.usersList.find(el => el.id == userId)?.name;
    }

    getQuestionnaireVisitTypes() {
        this.questionnaireService.getQuestionnaireVisitTypes().subscribe(resp => {
            this.questionnaireVisitTypes = resp
        })
    }


    public showMARButton = false;
    public getNotifications() {
        this.notificationsCopy = this.notifications;
        this.notifications = [];
        this.notificationService.getNotifications().then(nots => {
            if (nots) {
                nots = JSON.parse(nots);
                for (let n of nots) {
                    n.createdDateNew = new Date(n.createdDate + 'Z');
                    n.checked = false;
                    n.isExistOnPanle = this.notificationsCopy.find(x => x.id == n.id) ? true : false;//not to show again if the notification already exist on sidebar pannel
                }
                this.notifications = nots;
                this.showMARButton = false;
                this.showNotificationToastMsg(this.notifications);
                // this.checkOverdueNotification(this.notifications);
            }
        });
    }

    showNotificationToastMsg(notifications) {
        this.messageService.clear('notificationMsg');
        let msgArrays: any[] = notifications?.filter(item => item?.description?.startsWith("TaskOverdue") && !item?.isExistOnPanle)
            .map(item => ({ key: 'notificationMsg', summary: 'Notification', detail: item?.name, severity: 'warn', sticky: true, data: item }));
        if (msgArrays.length > 0 && !this.overdueMsgRead) {
            // this.messageService.addAll(msgArrays);
            this.messageService.add({ key: 'notificationMsg', summary: 'Notification', detail: 'You have overdue tasks', severity: 'error', sticky: true });
        }
    }

    checkOverdueNotification(notifications) {
        let msgArrays: any[] = notifications?.filter(item => item?.description?.startsWith("TaskOverdue"));
        if (msgArrays.length) {
            this.overdueNotificationService.setOverdueTasksAvaiable(true);
        } else {
            this.overdueNotificationService.setOverdueTasksAvaiable(false);
        }
    }

    onCloseNotificationMarkAsRead(event) {
        let selectedNotifications = [event.message.data.id];
        this.notificationService.markReadNotificationAll(selectedNotifications).then(ret => {
            this.getNotifications();
        });
    }

    onCloseNotificationToast(event) {
        this.overdueMsgRead = true;
    }

    getEmailRecipientsTypes() {
        this.typeService.lionO36020APIRecipientTypeGet().subscribe((res: Type[]) => {
            this.emailRecipTypes = res;
        });
    }

    loadWidget(item) {
        let w = { ...item, cols: 4, rows: 3, y: 0, x: 0, hasContent: true, dragEnabled: true, resizeEnabled: true, }
        this.currentUser.dashboard.push(w);
    }

    getDashboardDetails() {
        this.configurationData.subscribe(configs => {
            if (configs && configs.length) {
                if (configs.filter(s => s.name == 'Dashboard Configuration' && s.createdBy == this.user.userId && s.typeId == 65).length > 0) {

                    this.dashboardSetting = JSON.parse(configs.filter(s => s.name == 'Dashboard Configuration' && s.createdBy == this.user.userId && s.typeId == 65)[0].configurationDetails[0].configJSONValue);
                    this.dashboardconfigurationId = (configs.filter(s => s.name == 'Dashboard Configuration' && s.createdBy == this.user.userId && s.typeId == 65))[0].id
                    if (this.dashboardSetting.length > 0)
                        this.currentUser.dashboard = this.dashboardSetting;
                }
            }
        })
    }

    onMenuButtonClick(event: Event) {
        this.menuButtonClick = true;
        this.menuActive = !this.menuActive;
        event.preventDefault();
    }

    onTopbarMenuButtonClick(event: Event) {
        this.topbarMenuButtonClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;
        event.preventDefault();
    }

    onQuestionClick(event: Event) {
        this.questionMenuClick = true;
        this.questionMenuActive = !this.questionMenuActive;
        event.preventDefault();
    }

    onTopbarItemClick(event: Event, item: Element) {
        this.topbarMenuButtonClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }
        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onLayoutClick() {
        if (!this.menuButtonClick && !this.menuClick) {
            if (this.menuMode === 'horizontal') {
                this.menuService.reset();
            }

            if (this.isMobile() || this.menuMode === 'overlay' || this.menuMode === 'popup') {
                this.menuActive = false;
            }

            this.menuHoverActive = false;
        }

        if (!this.topbarMenuButtonClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.questionMenuClick) {
            this.questionMenuActive = false;
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        this.configClick = false;
        this.menuButtonClick = false;
        this.menuClick = false;
        this.topbarMenuButtonClick = false;
        this.questionMenuClick = false;
    }

    onRippleChange(event) {
        this.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onMenuClick() {
        this.menuClick = true;
    }

    isMobile() {
        return window.innerWidth < 1025;
    }

    isHorizontal() {
        return this.menuMode === 'horizontal';
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    public async getAllActivityLog(dateSearch, filter, PageNumber, PageSize, SearchValue, includeContactLogs, includeContactNotes, isEmailSync = false, isShowLoader = true) {
        let object = this.preLoadedObjects.map(elem => {
            return { name: elem.name, id: this.objectId, type: elem.id }
        });

        this.allObjects = object;
        this.objectTypeId = object.filter(elem => elem.name === this.objectType)[0]?.type || 0;
        if (this.objectTypeId == 0) { return; }

        let objectId = this.objectId;
        let objectTypeId = this.objectTypeId;

        if (!isEmailSync) {
            this.allActivityLogs = [];
        }

        if (isShowLoader && !isEmailSync) {
            this.appMainService.isShowSpinner('getAllActivities');
        }
        this.loadingActivityLogs = true;
        this.activityTaskService.getAllActivities(objectId, objectTypeId, dateSearch, filter, PageNumber, PageSize,
            SearchValue, includeContactLogs, includeContactNotes).subscribe((response) => {
                this.allActivityLogs = response;
                this.loadingActivityLogs = false;
                this.storeService.setActivityLogList(this.allActivityLogs);
                this.appMainService.isHideSpinner('getAllActivities');
            }, (error) => {
                if (error) {
                    this.allActivityLogsListErrorResponse = error.status;
                }
                this.loadingActivityLogs = false;
                this.appMainService.isHideSpinner('getAllActivities');
            });
    }

    public async getAllActivityLogList(dateSearch, filter, PageNumber, PageSize, SearchValue, includeContactLogs, includeContactNotes, isShowLoadeer = true) {
        let object = this.preLoadedObjects.map(elem => {
            return { name: elem.name, id: this.objectId, type: elem.id }
        });

        this.allObjects = object;
        this.objectTypeId = object.filter(elem => elem.name === this.objectType)[0]?.type || 0;
        if (this.objectTypeId == 0) { return; }

        let objectID = this.objectId;
        let objectTypeID = this.objectTypeId;

        isShowLoadeer && this.appMainService.isShowSpinner('getAllActivityLogList');
        this.allActivityLogsList = [];
        this.activityTaskService.getAllActivities(objectID, objectTypeID, dateSearch, filter, PageNumber, PageSize,
            SearchValue, includeContactLogs, includeContactNotes).subscribe((response) => {
                //this.allActivityLogs = response;
                this.allActivityLogsList = response;
                isShowLoadeer && this.appMainService.isHideSpinner('getAllActivityLogList');
            }, (error) => {
                if (error) {
                    this.allActivityLogsListErrorResponse = error.status;
                }
                isShowLoadeer && this.appMainService.isHideSpinner('getAllActivityLogList');
            })
    }

    public getAllObjects(isShowLoader = true, includeContactLogs = true, includeContactNotes = true) {
        let object = this.preLoadedObjects.map(elem => {
            return { name: elem.name, id: this.objectId, type: elem.id }
        });
 
        this.objectTypeId = object.filter(elem => elem.name === this.objectType)[0]?.type || 0;
        if (this.objectTypeId == 0) { return; }
        if ([AccountModuleId, LeadModuleId, OpportunityModuleId, CaseModuleId].includes(this.objectTypeId)) {
            this.activityDataService.reloadActivity();
        } else {
            this.getAllActivityLog("lasttenactivity", "allactivity", 1, 10, "", includeContactLogs, includeContactNotes, false, isShowLoader);
        }
    }

    getParsedHtml(html) {
        const newDoc = document.implementation.createHTMLDocument('doc');
        const dom = newDoc.createElement('div');
        dom.innerHTML = html;

        return dom.innerHTML;
    }

    convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();

        newDate.setHours(hours - offset);
        return newDate;
        //return date
    }

    checkoutAccount() {
        this.vendorUserService.lionO36020APIVendorOAuthRegistrationUserUserIdGet().subscribe((res: VendorOAuthRegistrationUser) => {
            if (res && res.statusId !== 2) {
                this.isConfigured = true;
                this.configuredUserBSubject.next(true)
                this.configuredUser = { ...res };
            } else {
                this.isConfigured = false;
                this.configuredUserBSubject.next(false)
            }
        });
    }
    getAllCategory() {
        this.categoryService.getGroups()
            .subscribe((group: any) => {
                let categoryId = group.find(e => e.name == "MarketPlace").id;

                this.categoryService.getCategories(categoryId)
                    .subscribe((cate: any) => {
                        let emailId = cate.find(e => e.name == "Email").id;

                        this.vendorService
                            .lionO36020APIVendorGet(emailId)
                            .subscribe((vendorRes: any) => {
                                for (let s of vendorRes) {
                                    if (s.venderOuthUserDTO !== null) {
                                        if (s.name == "Other SMTPs") {
                                            this.getSMTP(s);
                                            this.isSMTP = true;
                                        } else {
                                            this.checkoutAccount();
                                            this.isSMTP = false;
                                        }
                                    } else {
                                        this.isConfigured = false;
                                        this.configuredUserBSubject.next(false)
                                    }
                                }
                            });
                    });
            })
    }
    getSMTP(s) {
        this.emailService.getSMTPData()
            .toPromise()
            .then((res: VendorOAuthRegistrationUser) => {
                if (res) {
                    this.isConfigured = true;
                    this.configuredUserBSubject.next(true)
                    this.configuredUser = { ...res };
                }
            });
    }

    checkConfigurationAndPerformOps() {
        this.confirmationService.confirm({
            message: 'Do you want to sign out?',
            header: 'Sign Out',
            icon: 'pi pi-info-circle',
            key: 'confirm-signout',
            accept: () => {
                if (this.configuredUser) {
                    if (this.isSMTP) {
                        this.configuredUser.isOtherSMTP = true;
                    } else {
                        this.configuredUser.isOtherSMTP = false;
                    }
                    this.configuredUser.statusId = Status.InActive;
                    this.configuredUser.updatedBy = this.companyId;
                    this.configuredUser.updatedSource = this.userIP;
                    this.configuredUser.updatedDate = new Date();
                    this.configuredUser.vendorOAuthRegistrationId = this.configuredUser.vendorOAuthRegistration.vendorId;
                    this.vendorUserService.lionO36020APIVendorOAuthRegistrationUserPut(this.configuredUser).toPromise().then((res: Response) => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email unconfigured successfully...' });
                        this.zone.run(() => {
                            this.isConfigured = false;
                            this.configuredUserBSubject.next(false)
                            this.configuredUser = null;
                        });
                    }, (err) => { this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.text }); });
                }
            },
            reject: () => { }
        });
    }

    openNotification(notification) {

        if (notification.lionO360_Object.name == 'Stream') {
            this.router.navigate(['/stream']);
        } else if (notification.lionO360_Object.name == 'Task') {
            // this.router.navigate(['/profile']);
            this.selectedTaskId = notification.objectValue;
            this.displayEditViewTask = true;
        }
        else if (notification?.objectId === ModuleType.Estimate ||
            notification?.objectId === ModuleType.Invoice ||
            notification?.objectId === ModuleType.SalesOrder) {
            const approvalActivityInfo: ApprovalActivityInfo = {
                approvalId: notification?.objectValue,
                approvalInfoId: 0,
                statusId: notification?.statusId
            }
            this.approvalActivityInfo = { ...approvalActivityInfo }
            this.displayViewApproval = true;
        }
        else if (notification?.lionO360_Object?.name === workspaceModuleName) {
            const selectedParentComment = notification?.notificationAttribute[0]?.parentComment
            const selectedNotifications = [];
            selectedNotifications.push(notification?.id);
            this.notificationService.markReadNotificationAll(selectedNotifications).then(res => {
                this.getNotifications();
            });
            if (selectedParentComment === null) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Comment is deleted' });
                return;
            }
            this.selectedParentComment = {
                ...selectedParentComment,
                hasUnReadComments: selectedParentComment.hasUnReadComment, // Rename property
                commentNotificationId: notification?.notificationAttribute[0]?.transactionGId,
            };
            this.workbookId = notification?.notificationAttribute[0]?.channnelGId;
            this.rowNumber = notification?.notificationAttribute[0]?.objectRecordId;
            if (this.selectedParentComment && this.workbookId && this.rowNumber) {
                this.displayCommentDetailPopup = true;
            }
        }
        else if (notification?.notificationAttribute[0]?.transactionType === 'Log') {
            this.selectedModuleId = notification?.objectId;
            this.selectedAccountId = notification?.objectValue;
            this.openLogDetail(notification?.notificationAttribute[0].parentTransactionId , notification?.notificationAttribute[0], notification?.id);
        }
        else if (notification?.notificationAttribute[0]?.transactionType === 'Note') {
            this.selectedModuleId = notification?.objectId;
            this.selectedAccountId = notification?.objectValue;
            this.openNoteDetail(notification?.notificationAttribute[0].parentTransactionId, notification?.notificationAttribute[0], notification?.id);
        }

        else {
            this.router.navigate([notification.lionO360_Object.name.toLowerCase() + '/' + notification.objectValue]);
        }
        this.displayNote = false;
    }

    copyObjectWithoutRefrence(data) {
        return JSON.parse(JSON.stringify(data))
    }

    logout(reload = false) {
        this.tasksService.getTimerRunningTaskData().pipe(
            take(1),
            takeUntil(this.destroy$)).subscribe(runningTasks => {
                if (runningTasks?.length > 0 && runningTasks) {
                    this.confirmationService.confirm({
                        message: 'A task timer is running. Are you sure you want to log out?',
                        header: 'Timer Running!',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            clearInterval(this.interval);
                            this.stopAllRunningTasks();
                            this.tasksService.clearTimerRunningTaskData();
                            this.accountService.logout(reload);
                        },
                        reject: () => {
                            // Do nothing, just close the dialog
                        }
                    });
                } else {
                    clearInterval(this.interval);
                    this.accountService.logout(reload);
                }
            });
    }

    stopAllRunningTasks() {
        this.tasksService.getTimerRunningTaskData().pipe(
            take(1),
            takeUntil(this.destroy$)).subscribe(runningTasks => {
                runningTasks.forEach(task => {
                    this.stopTaskTimer(task);
                });
            });
    }

    stopTaskTimer(taskDetails: any) {
        if (taskDetails?.timerResponse?.id) {
            this.appMainService.isShowSpinner("getTaskTimer");
            this.tasksService.stopTaskTimer(taskDetails?.timerResponse?.id).subscribe({
                next: (response) => {
                    taskDetails['taskStartTime'] = null;
                    taskDetails['timerResponse'] = null;
                    this.appMainService.isHideSpinner("getTaskTimer");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getTaskTimer');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Failed To Stop Task Timer'
                    });
                }
            });
        }
    }

    decode(data) {
        const decrypted = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (decrypted) {
            try {
                const str = decrypted.toString(CryptoJS.enc.Utf8);
                if (str.length > 0) {
                    return JSON.parse(str);
                } else {
                    return 'error 1';
                }
            } catch (e) {
                return 'error 2';
            }
        }
        return 'error 3';
    }

    getTimezoneDate(date?, timestampParam?) {
        if (date) {
            const dateStr = date + '';
            if (!dateStr.endsWith('Z')) {
                date = date + 'Z';
            }
        }

        const dateDate = date ? new Date(date) : new Date();
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone) {
            const timestamp = sessionData.timeZone.Name.slice(4, 10).split(':').join('');
            const timestampData = timestampParam == 'utc' ? 0 : timestamp;
            return new Date(this.datePipe.transform(String(dateDate), 'MM/dd/yyyy h:mm a', timestampData));
        }
    }

    _showDateTimeWithZone(date) {
        if (date && typeof date === 'string') {
            date = convertToLocalDate(date);
            const dateStr = date + '';
            if (!dateStr.endsWith('Z')) {
                date = date + 'Z';
            }
        }

        let newDate = new Date(date);
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone) {
            const mDate = momentTz.tz(newDate, sessionData.timeZone.IANATimeZone);
            const timezonedDate = mDate.tz(sessionData.timeZone.IANATimeZone).format('MM/DD/YYYY h:m A')
            return new Date(timezonedDate);
        }
        return newDate;
    }

    _saveDateTimeWithZone(date, considerDayLight: boolean = true) {
        let userGMT = this.getUserGMT();
        date = date + '';
        date = date.split('GMT')[0];
        date = date.concat(` ${userGMT}`)
        const dateObj = new Date(date).toUTCString();
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        const timeZoneData = sessionData.timeZone;
        if (timeZoneData.isDayLight && considerDayLight) {
            return new Date(new Date(dateObj).getTime() - (parseInt(timeZoneData.dstOffSetTimeInSeconds) * 1000));
        }
        return new Date(dateObj);
    }

    getUserGMT() {
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        let name2 = sessionData.timeZone.Name;
        name2 = name2.replace('(', '');
        name2 = name2.replace(')', '');
        name2 = name2.split(' ')[0];

        return name2;
    }

    _showDateTimeWithZoneOld(date) {
        if (date && typeof date === 'string') {
            const dateStr = date + '';
            if (!dateStr.endsWith('Z')) {
                date = date + 'Z';
            }
        }

        let newDate = new Date(date);
        var timeOffsetMinute: number = new Date().getTimezoneOffset() * -1;
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone) {
            let munutes = 0;
            const timestamp = sessionData.timeZone.Name.slice(4, 10);
            let hourmin = timestamp.split(':');
            if (hourmin && hourmin.length == 2) {
                munutes = parseFloat(hourmin[0]) * 60;
                munutes = munutes + parseFloat(hourmin[1]);
            }
            let diff = munutes - timeOffsetMinute;
            newDate = new Date(newDate.getTime() + diff * 60000);
        }

        return newDate;
    }



    _saveDateTimeWithZoneOld(date) {
        let newDate = new Date(date);
        var timeOffsetMinute: number = new Date().getTimezoneOffset() * -1;
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone) {
            let munutes = 0;
            const timestamp = sessionData.timeZone.Name.slice(4, 10);
            let hourmin = timestamp.split(':');
            if (hourmin && hourmin.length == 2) {
                munutes = parseFloat(hourmin[0]) * 60;
                munutes = munutes + parseFloat(hourmin[1]);
            }
            let diff = timeOffsetMinute - munutes;
            newDate = new Date(newDate.getTime() + diff * 60000);
        }

        return newDate;
    }

    getTimeSlot(date, timeSlot) {
        const start = moment(date.toISOString());
        const remainder = timeSlot - (start.minute() % timeSlot);
        const dateTime = moment(start).add(remainder, "minutes").format("MM/DD/YYYY, hh:mm:ss A");
        return new Date(dateTime);
    }

    //Dashboard Widgets

    setDashboardWidgets(reportPemrission, userPermissions) {
        this.dashboardWidgets = [
            {
                name: 'Charts',
                modules: []
            },
            {
                name: 'Tables',
                modules: []
            }
        ];

        if (this.dashboardWidgetsList) {
            this.generateDashboarWidgetsMenus(this.dashboardWidgetsList, reportPemrission, userPermissions);
        } else {
            this.dashboardService.getDashboardWidgetList().subscribe(response => {
                if (response) {
                    this.dashboardWidgetsList = response;
                    this.generateDashboarWidgetsMenus(this.dashboardWidgetsList, reportPemrission, userPermissions);
                }
            })
        }
    }

    generateDashboarWidgetsMenus(widgetList: DashboardViewContentWidgetModels[], reportPemrission, userPermissions) {
        this.summaryWidgetsList = widgetList.filter(widget => widget.widgetName == 'summary_widget');
        const permittedWidgetList = widgetList.filter(widget => this.checkGetPermission(widget, reportPemrission, userPermissions) && widget.widgetName != 'summary_widget' && !['financeGrossSales'].includes(widget.widgetCode));
        const chartList = permittedWidgetList.filter(widget => !widget.dashBoardChartMaster?.name?.toLowerCase().includes('table'));
        const tableList = permittedWidgetList.filter(widget => widget.dashBoardChartMaster?.name?.toLowerCase().includes('table'));

        const chartMenus = chartList?.length > 0 ? arrayGroupByKey(chartList, 'moduleId') : [];
        const tableMenus = tableList?.length > 0 ? arrayGroupByKey(tableList, 'moduleId') : [];

        chartMenus?.map((menus: any) => {
            if (menus?.dataList?.length > 0) {
                this.dashboardWidgets[0].modules.push({
                    widgetType: DashboardContentChartTypes.charts,
                    name: menus?.dataList[0].lionO360_Object?.name || 'Others',
                    items: menus?.dataList
                })
            }
        })

        tableMenus?.map((menus: any) => {
            if (menus?.dataList?.length > 0) {
                this.dashboardWidgets[1].modules.push({
                    widgetType: DashboardContentChartTypes.table,
                    name: menus?.dataList[0].lionO360_Object?.name || 'Others',
                    items: menus?.dataList
                })
            }
        })
    }

    checkGetPermission(dashboardWidget: DashboardViewContentWidgetModels, reportPermissionData, userPermissionData) {

        const reportItems = this.reportsAllMenus.find(menu => menu.reportType == dashboardWidget.widgetName);
        const selectedMenu = reportItems?.items?.find(item => item.reportType == dashboardWidget.widgetCode);

        if (reportItems?.permissionName) {
            const parentPermission = reportPermissionData.filter(c => c.objectName == reportItems.permissionName)[0]?.permissions?.filter(x => x.permissionName == 'Read')[0].statusId == 1;
            if (!parentPermission) { return false; }
        }

        if (selectedMenu && selectedMenu?.permissionName) {
            if (reportPermissionData != undefined && reportPermissionData.filter(c => c.objectName == selectedMenu?.permissionName).length > 0) {
                if ((reportPermissionData.filter(c => c.objectName == selectedMenu?.permissionName)[0]?.permissions?.filter(x => x.permissionName == 'Read')[0].statusId == 1)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }

        }

        if (dashboardWidget.widgetName == 'territory_map') {
            const territoryUserPermission = userPermissionData.find(obj => obj.objectName === ObjectNames.TERRITORY);
            const territoryMenuPermission = territoryUserPermission ? (territoryUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
            return territoryMenuPermission;
        }

        return true;
    }

    addDashboardContent(item: DashboardWidgetListModels, widgetType: typeDashboardContentChartTypes) {
        this.dashboardDataService.sendData<DashboardDataServiceActions>({ actionType: DashboardDataServiceActionsValues.addChart, content: item, widgetType: widgetType });
    }

    //#region  ***User Cookie***

    openCookieDialog() {
        let cookiesAcceptance = this.cookieStoreService.isCookieAccepted();
        if (cookiesAcceptance === null) {
            this.isShowCookie = true;
        }
    }

    openCookieSetting() {
        this.displayCookieSetting = true;
    }

    advanceCookieAcceptance() {
        const accepted = this.cookies[1].isActive;
        this.cookieAcceptance(accepted);
    }

    cookieAcceptance(accepted: boolean) {
        this.isShowCookie = false;
        this.displayCookieSetting = false;
        this.userService.saveCookies(accepted).subscribe({
            next: () => {
                this.cookieStoreService.setCookieAcceptance(accepted);
                if (accepted) {
                    this.saveUserPreferenceInCookies();
                }


            }
        })
    }

    saveUserPreferenceInCookies() {
        this.profileService.getUserPreference().subscribe((preference: any) => {
            if (preference) {
                this.cookieStoreService.setUserPreferenceCookie(preference);
            }
        });
    }

    denyCookie() {
        this.isShowCookie = false;
        this.displayCookieSetting = false;
    }

    //#endregion ***User Cookie***


    //chatbot
    onCancelChatBotDialog(event) {
        this.chatBotInitializationData = event;
        this.chatbotModules = [];
        this.displayChatBox = false;
        this.selectedChatbotWindow = null;
    }

    //clock
    cancelClicked(event) {
        this.displayEditViewTask = false;
    }

    onUpdateComplete(event) {
        this.tasksService.createUpdateTask(this.filterMode);
        this.tasksService.notifyTaskUpdate();
    }
    //Comments
    hideCommentDetails() {
        this.displayCommentDetailPopup = false;
        this.selectedParentComment = null;
        this.workbookId = null;
        this.rowNumber = null;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.tasksService.clearTimerRunningTaskData();
    }

    formatToUserUTCDate(date: Date, gmtOffset: string = 'GMT+00:00', includeEndingTime: boolean = false): any {
        const originalDate = new Date(moment(date).format('MM-DD-YYYY'));
        let adjustedDate = this.getUtcDateFromTimezone(originalDate, gmtOffset);
        if (includeEndingTime) {
            adjustedDate = moment(adjustedDate).add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds').toDate();
        }
        return adjustedDate;
    }

    getUtcDateFromTimezone(localDate: Date, gmtOffset: string, considerDayLight: boolean = true): Date {
        const offsetMatch = gmtOffset.match(/GMT([+-])(\d{2}):(\d{2})/);
        if (!offsetMatch) {
            throw new Error("Invalid GMT offset format. Expected format: 'GMT+HH:mm' or 'GMT-HH:mm'");
        }
        const sign = offsetMatch[1] === "+" ? 1 : -1; // Determine if the offset is positive or negative
        const hours = parseInt(offsetMatch[2], 10); // Extract hours
        const minutes = parseInt(offsetMatch[3], 10); // Extract minutes
        // Calculate the total offset in milliseconds
        const offsetMilliseconds = sign * (hours * 60 * 60 * 1000 + minutes * 60 * 1000);
        const utcDate: Date = new Date(JSON.parse(JSON.stringify(localDate)));
        const localOffset = utcDate.getTimezoneOffset() * 60 * 1000;
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        const timeZoneData = sessionData.timeZone;
        let dayLightOffset = 0;
        if (timeZoneData.isDayLight && considerDayLight) {
            dayLightOffset = parseInt(timeZoneData?.dstOffSetTimeInSeconds ?? 0) * 1000;
        }
        // Subtract the offset to get UTC date
        return new Date(utcDate.getTime() - offsetMilliseconds - localOffset - dayLightOffset);
    }


    openLogDetail(logId, notificationData, notificationId) {
        this.logService.lionO36020APILogIdGet(logId).subscribe({
            next: (log: any) => {
                this.displayLogDetailPopup = true;
                this.logData = log;
                this.markNotificationAsRead(notificationId);
                this.readUnreadNotifcation(this.logData,'Log');
            },
            error: (err) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.Message });
                this.markNotificationAsRead(notificationId);
            }
        });
    }

    cancelLogPopupDetails() {
        this.logData = null;
        this.displayLogDetailPopup = false;
    }

    openNoteDetail(noteId, notificationData, notificationId) {
        this.noteService.lionO36020APINoteIdGet(noteId).subscribe({
            next: (note) => {
                this.displayNoteDetailPopup = true;
                this.noteData = note;
                this.markNotificationAsRead(notificationId);
                this.readUnreadNotifcation(this.noteData,'Note');
            },
            error: (err) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.Message });
                this.markNotificationAsRead(notificationId);
            }
        });
    }

    cancelNotePopupDetails() {
        this.noteData = null;
        this.displayNoteDetailPopup = false;
    }

    markNotificationAsRead(notificationId:any) {
        const selectedNotifications = [];
        selectedNotifications.push(notificationId);
        this.notificationService.markReadNotificationAll(selectedNotifications).then(res => {
            this.getNotifications();
        });
    }

    readUnreadNotifcation(logData: any, type: 'Log'|'Note'): void {
        if (!logData) return;

        const comments = logData?.logComments||logData?.noteComments||[];
        const unreadComments: ReadActivitiesByIdsPayload[] = comments.filter(n=> n.isRead===false).map(log=>{
            return {
                objectId: this.objectTypeId,
                objectRecordId: this.objectId,
                logType: 'Comment',
                logId: log?.commentId
            }
        });

        if(logData?.isRead===false){
            unreadComments.push({
                objectId: this.objectTypeId,
                objectRecordId: this.objectId,
                logType: type,
                logId: this.logData?.id
            })
        }

        this.notificationService.readActivitiesByIds(unreadComments).subscribe({
            error: () => { }
        });
    }

}
